import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OutputOrderRequest, OutputOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage/api';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { GetOutputOrderExcelDataAdapter } from '../adapters/outputOrderExcelDataAdapter';
import { OutputOrderExcelData } from '../domains/entities/orderResponse';

/**
 *　発注エクセルのテンプレート取得を行う
 */
export class OutputOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 出力用発注エクセルのテンプレートを取得する
   * @param orderIds - 発注IDの配列
   * @param templateId - 利用するテンプレートID
   */
  public async Execute(orderIds: string[], templateId?: string): Promise<INetworkResult<OutputOrderExcelData, IError>> {
    // リクエスト情報作成
    const outputOrderRequest: OutputOrderRequest = {
      targetOrderIds: orderIds,
    };
    if (templateId) {
      outputOrderRequest.template = {
        templateId,
      };
    }
    try {
      const response = await this.repository.outputOrder(outputOrderRequest);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error('Invalid status');
      }

      // ここでアダプタを使用してExcelをダウンロードする
      const data = await GetOutputOrderExcelDataAdapter.adaptForResponse(response.status.data as OutputOrderResponseResult);

      return {
        status: {
          type: 'success',
          data: data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
